import { ATGBasketResponse, BasketAddItemOptions, BasketResponse } from 'types/BasketTypes';
import { BasketServiceInterface } from '../interface/BasketServiceInterface';
import adaptBasketResponse from '../adaptors/adaptBasketResponse';

export default class ATGBasketService implements BasketServiceInterface {
  async addItem({ item, csrfToken, sessionConfirmationNumber }: BasketAddItemOptions): Promise<BasketResponse> {
    if (!sessionConfirmationNumber || typeof sessionConfirmationNumber !== 'string') {
      throw new Error('Session confirmation number is required to add an item to the basket.');
    }

    if (!csrfToken || typeof csrfToken !== 'string') {
      throw new Error('CSRF token is required to add an item to the basket.');
    }

    const response = await fetch(
      `/rest/model/atg/commerce/order/purchase/CartModifierActor/addVariantToOrder?_dynSessConf=${sessionConfirmationNumber}`,
      {
        headers: {
          'Content-Type': 'application/json',
          'x-csrf-token': csrfToken,
        },
        method: 'POST',
        body: JSON.stringify(item),
      },
    );

    const data = (await response.json()) as ATGBasketResponse;

    return adaptBasketResponse({
      ...data,
      ok: response.ok,
      status: response.status,
      statusText: response.statusText,
    });
  }

  async amendItem(): Promise<never> {
    throw new Error('amendItem is not implemented for ATGBasketService.');
  }
}
